export default __webpack_public_path__ + "static/media/stack_logos-react.f1d1a4d2.png";